import mixins from '@synergycms_core/less/mixins.js';

export default {
    DESK :{},
    MOBIL:{},
    TABLET:{},
    inDispoContainer:{},
    dispoModal:{},
    inputEngineTitle: data => ({
        font: '600 12px/13px ' + data.fontFamily1,
        letterSpacing:'1.54px',
        textTransform:'uppercase',
        display:'block',
        paddingLeft:'40px',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        color:'#4a4a4a',
        [`@media (min-width: ${data.modalBreak}px)`]:{
          paddingLeft:'13px',
          paddingTop:'13px',
          '&:lang(ar)':{
            paddingLeft: '0',
            paddingRight: '13px',
            textAlign: 'right',
          }
        }
    }),
    defaultStyle: data => ({
        color: '#000',
        position: 'relative',
        marginBottom: '10px',
        backgroundColor: '#fff',
        [`@media (min-width: ${data.modalBreak}px)`]:{
            width: '33.47%',
            display: 'table-cell',
            background: 'none',
            verticalAlign: 'middle',
            '&$roundedTheme':{
                borderRadius: 'unset',
                '& $searchContainerChildren':{
                    borderRadius: '25px 0 0 25px',
                    '& $searchBoxInput':{
                        borderRadius: '25px 0 0 25px',
                    }
                },
            }
        }
    }),
    searchBoxInput: data => ({
        width: '100%',
        paddingLeft: '44px',
        zIndex: 1,
        height: '40px',
        boxSizing: 'border-box',
        border: 'none',
        font: '13px ' + data.fontFamily1,
        color: '#000',
        outline:'none',
        letterSpacing:'0.80px',
        '&::placeholder': {
          color: "black",
          opacity: 1,
        },
        '&:focus': {
          '&::placeholder': {
            color: "grey",
          }
        },
        [`@media (min-width: ${data.modalBreak}px)`]: {
          height: '49px'
        },
        '&:lang(ar)': {
          paddingLeft: '0',
          paddingRight: '44px',
          direction: 'rtl'
        }
    }),
    iconsEngine: data => ({
        position: 'absolute',
        fontSize: '22px',
        lineHeight: '40px',
        left: '12px',
        top: 0,
        color: data.mainColor,
        [`@media (min-width: ${data.modalBreak}px)`]: {
          lineHeight: '50px'
        },
        '&:lang(ar)': {
          left: 'auto',
          right: '12px'
        }
    }),
    searchContainerChildren: data => ({
        display:'block',
        '&:focus':{
          outline:'1px solid #000'
        },
        [`@media (min-width: ${data.modalBreak}px)`]: {
          background:'#fff',
          borderRight: '1px solid #d8d8d8'
        }
    }),
    inputEnter: {
        transition: 'max-height 0ms ease-out',
        maxHeight: '0',
        transitionDelay: '.3s',
        marginBottom: 0
    },
    inputEnterActive: {
        maxHeight: '100px',
        transition: 'max-height 300ms ease-out,margin-bottom .3s ease-out',
        overflow: 'hidden',
        transitionDelay: '.3s',
        marginBottom: '10px'
    },
    inputLeave: {
        maxHeight: '100px',
        transition: 'max-height 300ms ease-out',
        overflow: 'hidden'
    },
    inputLeaveActive: {
        transition: 'max-height 0 ease-out',
        marginBottom: '0',
        maxHeight: '0'
    },
    matchedText: {
        display: 'block',
        position: 'absolute',
        left: '44px',
        top: '50%',
        font: data => '300 13px/13px ' + data.fontFamily1,
        zIndex: 1,
        color: '#7f7f7f',
        letterSpacing:'0.78px',
        marginTop:'-6.5px',
        whiteSpace:'nowrap',
        width:'calc(100% - 44px)',
        overflow:'hidden',
        textAlign:'left',
        '& strong': {
            color:'#000',
            visibility: 'hidden'
        },
        '&:lang(ar)': {
            left: '5px',
            right: 'auto',
            display: 'flex',
            gap: '10px',
        }
    },
    portalDesign: data => ({
        '&:not($dispoModal)':{
            marginBottom: 0,
            display: 'inline-block',
            [`@media (max-width: ${data.modalBreak - 1}px)`]:{
                width: 'calc(100% - 90px)',
            },
            verticalAlign: 'middle',
            '& $searchBoxInput': {
                    height:'55px',
                    color:'#000',
                    fontSize:'15px',
                    paddingLeft:'40px',
                    '&::placeholder':{
                        color:'#4a4a4a',
                        fontWeight:'600',
                        fontSize:'12px',
                        textTransform:'uppercase',
                        letterSpacing:'1.54px',
                        [`@media (min-width: ${data.modalBreak}px)`]:{
                            color:'#7f7f7f',
                            textTransform:'unset',
                            fontSize: 'unset',
                            fontWeight:'300',
                            letterSpacing:'unset',
                        }
                    },
                    [`@media (min-width: ${data.modalBreak}px)`]:{
                        height:'54px',
                        fontSize:'15px',
                        letterSpacing:'0.80px'
                    }
            },
            '& $iconsEngine':{
                top:'auto',
                bottom:'0',
                lineHeight:'55px',
                [`@media (min-width: ${data.modalBreak}px)`]:{
                    lineHeight:'54px',
                    zIndex: '2'
                }
            },
            /*'& $searchContainerChildren':{
                '& $inputEngineTitle':{
                    textAlign: 'left'
                }
            },*/
            '& $inDispoContainer':{
                paddingRight: '40px',
                '& $searchContainerChildren':{
                    display: 'flex',
                    height: '100%',
                    alignItems: 'flex-end',
                    '& $inputEngineTitle':{
                        position: 'absolute',
                        top: '0',
                        left: '0',
                    }
                }
            },
            '& $searchContainerChildren':{
                display: 'flex',
                height: '100%',
                alignItems: 'flex-end',
                '& $inputEngineTitle':{
                    position: 'absolute',
                    top: '0',
                    left: '0',
                }
            },
            '& $matchedText':{
                bottom:0,
                top:'auto',
                lineHeight:'55px',
                pointerEvents:'none',
                [`@media (min-width: ${data.modalBreak}px)`]:{
                    lineHeight:'54px',
                    fontSize:'15px',
                    left:'40px'
                }
            },
        }
    }),
    roundedTheme:{
        borderRadius: '25px',
        '& $searchContainerChildren':{
            '& $searchBoxInput':{
                borderRadius: '25px',
            }
        },
        '& :not($dispoModal)':{
            '& $iconsEngine':{
                fontSize: '17px',
                left: '17px',
                '@media(max-width:800px)':{
                    top: '2px',
                }
            },
        }
    }

};